import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCardAmex = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 41 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 41,
		height: 18,
		rx: 3,
		fill: "#2E77BB"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9.49121 5.83789L7.36719 12H6.08301L8.75879 4.89062H9.5791L9.49121 5.83789ZM11.2686 12L9.13965 5.83789L9.04688 4.89062H9.87207L12.5576 12H11.2686ZM11.166 9.36328V10.335H7.29883V9.36328H11.166ZM14.3516 4.89062H15.4453L17.501 10.374L19.5518 4.89062H20.6455L17.9307 12H17.0615L14.3516 4.89062ZM13.8535 4.89062H14.8936L15.0742 9.63672V12H13.8535V4.89062ZM20.1035 4.89062H21.1484V12H19.9229V9.63672L20.1035 4.89062ZM27.7568 11.0283V12H23.9824V11.0283H27.7568ZM24.3291 4.89062V12H23.1035V4.89062H24.3291ZM27.2637 7.85938V8.81641H23.9824V7.85938H27.2637ZM27.7324 4.89062V5.86719H23.9824V4.89062H27.7324ZM30.1904 4.89062L31.6992 7.4834L33.208 4.89062H34.6191L32.4707 8.41113L34.6729 12H33.2471L31.6992 9.3584L30.1514 12H28.7207L30.9277 8.41113L28.7744 4.89062H30.1904Z",
		fill: "white"
	})]
});
export default SvgCardAmex;
